"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/*
 * Show licensing status and dates
 *
 * "renderAs": {
        "type": "License",
        "class": "html",
        "settings": {}
    }
 */
var _default = exports["default"] = function _default(settings) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: row,
      className: _style["default"].container
    }, /*#__PURE__*/_react["default"].createElement("span", null, "Licensing"));
  };
};